import { type ReactNode } from 'react';
import { Alert } from 'react-bootstrap';

export interface FormAlertProps {
    children?: ReactNode;
    variant?: 'danger' | 'success' | 'warning' | 'info';
    onClose?: () => void;
}

/** Top-of-form status banner. Renders nothing when there's no message. */
export function FormAlert({ children, variant = 'danger', onClose }: FormAlertProps) {
    if (!children) return null;
    return (
        <Alert variant={variant} dismissible={!!onClose} onClose={onClose} className="mb-3">
            {children}
        </Alert>
    );
}
